module.exports = (__webpack_require__("49fU"))(189);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/process/browser.js from dll-reference vendor_library
// module id = W2nU
// module chunks = 23